var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"shounin-comment-card",attrs:{"body-style":_vm.shouninCommentCardStyle}},[_c('el-icon',{staticClass:"el-icon-chat-line-round",attrs:{"type":"success"}}),_vm._v(" "+_vm._s(_vm.comment)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }